import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlaInfo } from '../../../order-v2.types';
import { LogisticsCardComponent, LogisticsCardField } from '../logistics-card/logistics-card.component';

@Component({
  selector: 'app-sla-card',
  standalone: true,
  imports: [CommonModule, LogisticsCardComponent],
  template: `<app-logistics-card title="SLA da entrega" [fields]="fields()" />`,
})
export class SlaCardComponent {
  private readonly _sla = signal<SlaInfo | null>(null);
  @Input({ required: true }) set sla(value: SlaInfo) {
    this._sla.set(value);
  }

  readonly fields = computed<LogisticsCardField[]>(() => {
    const sla = this._sla();
    if (!sla) return [];
    return [
      { label: 'data de entrega', value: sla.deliveryDate },
      { label: 'dias úteis para entrega', value: sla.businessDaysToDeliver },
      { label: 'tipo de entrega', value: sla.deliveryType },
      sla.scheduling
        ? {
            label: `periodo ${sla.scheduling.typeLabel}`,
            value: `${sla.scheduling.windowStart} — ${sla.scheduling.windowEnd}`,
          }
        : { label: 'periodo', value: null },
    ];
  });
}
